import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AcumuladoresService {

  readonly serviceApi = environment.apiUrl;

  constructor(private readonly http: HttpClient) { }

  requestAcumuladores(empresaId: number) {
    return this.http.get(`${this.serviceApi}/v1/dominio-reports/acumuladores-report`, {
      params: { empresaId }
    });
  }
}
